import {
    apiRegister
} from '../../common/api';

import {
    isNumber,
    isArray
} from '../../common/utils';
import {
    ERR_REQ_CUP_ID,
    ERR_REP_RANK_LIST
} from '../../common/const';
import { cleanUsers } from './utils';

/*
协议Id 
889
项目 
模块 
方式 
https 
命令（路径） 
/award/reality/rankformatch/
说明
比赛活动，实盘比赛得分排行榜，全部完成才可上榜
请求参数
参数名称	参数类型	说明
cupId	int
*/

const realityRank = apiRegister('rank-reality', {
    protoId: 889,
    path: '/award/reality/rankformatch/',
    checkQuery(Q) {
        if (!isNumber(Q.cupId)) {
            return ERR_REQ_CUP_ID // 参数错误
        }
        return 0
    },
    checkResult(R) {
        if (!isArray(R.rankList)) {
            return ERR_REP_RANK_LIST // 数据格式非法
        }
        return 0
    },
    formatResult(R) {
        const {
            myRank,
            rankList,
            userInfos
        } = R
        return {
            myRank,
            rankList,
            userMap: cleanUsers(userInfos, true)
        }
    }
})

export const realityRankLoad = realityRank.send
